const reasons = [
  {
    icon: 'ri-focus-3-line',
    title: 'Развитие начинается не с обучения',
    desc: 'Мы сначала определяем, какую компетенцию необходимо развить и зачем.',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'Ориентация на реальные задачи',
    desc: 'Цели развития связываются с рабочими ситуациями, а не только с прохождением курсов.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Практика',
    desc: 'Навык развивается через применение, а не только через получение информации.',
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Обратная связь',
    desc: 'Сотрудник получает возможность понять, что получается, а что необходимо изменить.',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: 'Связь с обучением',
    desc: 'Если обучение действительно необходимо, оно становится частью конкретного плана развития.',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Сопровождение',
    desc: 'При необходимости компания получает поддержку при внедрении изменений.',
  },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Принципы, на которых строится разработка и внедрение ИПР
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((r, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${r.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{r.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-base md:text-lg font-medium text-gray-800 mt-10 max-w-3xl mx-auto leading-relaxed">
          Наша задача — не составить красивый документ ИПР, а создать работающий механизм развития сотрудника.
        </p>
      </div>
    </section>
  );
}